import "./ExpertQueue.scss";

/** Counts on the left ("3 swap · 1 ignored · 6 not reviewed") and bulk actions on the right. */
export function TriageToolbar({
    counts,
    actions,
}: {
    counts: Array<{ label: string; value: number }>;
    actions: Array<{ label: string; onClick: () => void }>;
}) {
    return (
        <div className="triage-toolbar">
            <span className="triage-toolbar-counts">
                {counts.map((count, index) => (
                    <span key={count.label}>
                        {index > 0 ? " · " : ""}
                        <strong>{count.value}</strong> {count.label}
                    </span>
                ))}
            </span>
            <span className="triage-toolbar-actions">
                {actions.map((action) => (
                    <button
                        key={action.label}
                        type="button"
                        className="triage-button"
                        onClick={action.onClick}
                    >
                        {action.label}
                    </button>
                ))}
            </span>
        </div>
    );
}

/** A choice that stays pressed; pressing it again clears it. */
export function ChoiceButton({
    label,
    pressed,
    tone,
    onClick,
}: {
    label: string;
    pressed: boolean;
    tone: "act" | "ignore";
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            className={`triage-button triage-button--${tone}`}
            aria-pressed={pressed}
            onClick={onClick}
        >
            {label}
        </button>
    );
}

/** What a choice does today: nothing leaves the screen. Said out loud so nobody assumes otherwise. */
export function TriageNotice({ what }: { what: string }) {
    return (
        <p className="triage-notice">
            {what} Your choices are for your own review: approving creates the
            Jira task from the finding and does not include them yet.
        </p>
    );
}
